module.exports = __webpack_public_path__ + "media/images/area/icon_weather_16-e7d0824283dd055f2483e8cfa8a25c73.png";